import type { UserType } from '../types/user'

/**
 * Check if a user can accept project/workorder invitations
 * Only OWNER, PROJECT_MANAGER, and ADMINISTRATOR users can accept
 */
export const canUserAcceptInvitations = (userType: UserType): boolean => {
  return ['OWNER', 'PROJECT_MANAGER', 'ADMINISTRATOR'].includes(userType)
}

/**
 * Get the display text for invitation status
 */
export const getInvitationStatusText = (status?: string) => {
  switch (status) {
    case 'PENDING_INVITATIONS':
      return 'Pending Invitations'
    case 'PARTIALLY_ACCEPTED':
      return 'Partially Accepted'
    case 'FULLY_ACCEPTED':
      return 'Fully Accepted'
    default:
      return 'Unknown Status'
  }
}

/**
 * Get the progress percentage for invitation acceptance
 */
export const getInvitationProgress = (accepted = 0, total = 0) => {
  if (total === 0) return 0
  return Math.round((accepted / total) * 100)
}

/**
 * Check if all invitations have been accepted
 */
export const areAllInvitationsAccepted = (accepted = 0, total = 0) => {
  return total > 0 && accepted >= total
}
